import Helpers from '../../common/helpers/Helpers';
import Constants from '../../common/constants/Constants';

export const getFleetDetails = (fleetId) => {
  return Helpers.get(`${Constants.FLEETS_URL}/${fleetId}`);
};

export const getFleetReportList = () => {
  return Helpers.get(`${Constants.FLEET_REPORTSLIST_URL}`);
};
